import { RoutePath } from "#src/utils/route";
import { FormTemplateDetailsRoute } from "..";

export const FormSubmissionsDownloadPDFsRoute = FormTemplateDetailsRoute.concat(
  new RoutePath({
    path: "/download",
    title: "Download Form Submissions PDFs",
    queryParams: {
      submissionType: "all",
    },
  })
);

export * from "./FormSubmissionsDownloadPDFsPage";
